<template>
  <div class="recruit">
    <div class="back-img"></div>
    <div class="content">
      <el-button
        class="el-primary-border all-btn"
        :class="{ btn_none: btnAll }"
        type="primary"
        style="margin-left:0"
        @click="handleBtn(true, '总部')"
        >集团招聘</el-button
      >
      <h4>子公司招聘</h4>
      <el-button
        type="primary"
        class="el-btn"
        :class="{ active_btn: index === isBtn }"
        v-for="(item, index) in cityData"
        :key="index"
        @click="handleBtn(index, item)"
        >{{ item }}</el-button
      >
      <div class="msg" v-for="(msg, index) in dataMsg" :key="'msg-' + index">
        <div class="name" style="min-width:70px;text-align: center;">
          {{ msg.post_name }}
        </div>
        <div>{{ msg.num }}</div>
        <div style="min-width:70px;text-align: center;">{{ msg.address }}</div>
        <div class="money">{{ msg.salary }}</div>
        <div>{{ msg.issue_time }}</div>
        <router-link
          :to="{
            path: ylStatus
              ? `/recruitMsg_yl/${msg.id}`
              : `/recruitMsg/${msg.id}`
          }"
        >
          <div class="more">查看详情>></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getProvince, getRecruitList } from '@/api/recruit'
export default {
  data() {
    return {
      isBtn: '',
      btnAll: false,
      cityData: [],
      dataMsg: [],
      ylStatus: this.$store.getters.urlStatus
    }
  },
  created() {
    this.init()
    this.getMsg('总部')
  },
  methods: {
    //获取省份
    init() {
      getProvince()
        .then(res => {
          this.cityData = res.data
          delete this.cityData[0]
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getProvince').then(res => {
      //   if (res.data.code) {
      //     this.cityData = res.data.data
      //     delete this.cityData[0]
      //   }
      // })
    },
    //招聘列表
    getMsg(name) {
      const data = { company_code: name }
      getRecruitList(data)
        .then(res => {
          let list = res.data.list
          this.dataMsg = list
          if (list.length === 0) {
            this.Message.warning('暂无信息')
          }
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getRecruitList', data).then(res => {
      //   let data = res.data.data.list
      //   this.dataMsg = data
      //   if (data.length === 0) {
      //     this.Message.warning('暂无信息')
      //   }
      // })
    },
    //切换省份
    handleBtn(index, name) {
      if (typeof index === 'boolean') {
        this.btnAll = false
        this.isBtn = ''
      } else {
        this.isBtn = index
        this.btnAll = true
      }
      this.getMsg(name)
    }
  }
}
</script>

<style lang="scss" scope>
.recruit {
  .back-img {
    background-image: url('../../assets/image/recruit.png');
    margin-top: -62px;
    padding-bottom: 25%;
  }
  .content {
    text-align: start;
    text-align: initial;
    padding: 50px 250px;
    .all-btn {
      color: #fff;
      border-radius: 0;
      background: #0590ff !important;
    }
    h4 {
      font-size: 18px;
      font-weight: 400;
      color: rgba(13, 126, 248, 1);
      margin: 30px 10px 20px 10px;
    }
    .el-primary-border {
      margin: 10px;
    }
    .el-btn {
      width: 88px;
      margin: 15px 10px 15px 0px;
      background: #fff;
      color: #62697b;
      border-radius: 0;
      border-color: rgba(227, 231, 237, 1);
    }
    .active_btn {
      color: #fff;
      background: #0590ff !important;
    }
    .btn_none {
      background: #fff !important;
      color: #62697b !important;
      border-color: rgba(227, 231, 237, 1);
    }
    .msg {
      display: flex;
      justify-content: space-between;
      margin: 50px 10px 0 10px;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(117, 123, 128, 1);
      border-bottom: 1px solid #e8e8e8;
      .name {
        font-size: 14px;
        font-weight: 400;
        color: rgba(13, 126, 248, 1);
      }
      .money {
        color: #fa774f;
      }
      .more {
        cursor: pointer;
      }
      .more:hover {
        color: #0d7ef8;
      }
    }
  }
}
</style>
